import React from 'react';
import { Box, Button, Grid, Typography, useMediaQuery } from '@material-ui/core';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { useHistory } from "react-router-dom";  // ✅ Only this for React Router v5

const HeroSection = () => {
     const history = useHistory();
     const isMobile = useMediaQuery("(max-width:600px)");
     // Demo video served from CRA public folder:
     // montessori_ui/public/images/home.mp4
     const demoVideo = '/images/home.mp4?v=20260330_1';
  return (
    <Box
      style={{
        backgroundColor: '#f7f9fc',
        width: "100%",
        padding: isMobile ? 16 : 40,
      }}
    >
      <Grid container spacing={isMobile ? 2 : 4} alignItems="center">
        {/* Left: copy + CTAs (md row 1 col left; xs order 1) */}
        <Grid item xs={12} md={6} style={{ order: 1 }}>
          <Typography
            variant={isMobile ? "h4" : "h2"}
            style={{
              fontWeight: 900,
              marginBottom: isMobile ? 12 : 16,
              lineHeight: 1.15,
              fontSize: isMobile ? "1.65rem" : "2.65rem",
            }}
          >
            Exclusive Montessori methodology, <br />
            based application for Montessori schools
          </Typography>
          <Typography
            variant="body1"
            style={{
              marginBottom: isMobile ? 16 : 24,
              fontSize: isMobile ? 15 : 17,
              lineHeight: 1.7,
              fontWeight: 500,
            }}
          >
          Designed exclusively for Montessori schools, our web-based management platform seamlessly aligns with the Montessori philosophy of hands-on, activity-based learning. It streamlines curriculum planning and student progress tracking through a structured system of <b>Areas of Work, Activities, and Exercises, </b> empowering educators to assign personalized next steps in every child’s learning journey.
The platform includes a <b>Activity Planner</b> and comprehensive <b>ready-made lesson plans</b>—complete with objectives, materials, and key learning points—making lesson preparation efficient and consistent across classrooms.
Powerful administrative tools for <b>attendance, admissions, and assignment management</b>   simplify day-to-day operations, allowing teachers and staff to focus more on student development.
A dedicated <b>Parent Module</b> keeps families actively engaged with real-time updates on student activities, teacher observations, and important alerts—fostering a cohesive and collaborative school community.
Complemented by <b>mobile apps for teachers and parents,</b> the system ensures effortless access and communication—anytime, anywhere.

          </Typography>

          <Box display="flex" alignItems="center" mb={isMobile ? 2 : 4} flexWrap="wrap" style={{ gap: 12 }}>
            <Button
              variant="contained"
              color="primary"
              style={{ textTransform: "none" }}
              onClick={() => history.push("/montessori/schoolregistration")}
            >
              Get Started Today
            </Button>
            <Button
              component="a"
              href={demoVideo}
              target="_blank"
              rel="noopener noreferrer"
              variant="outlined"
              style={{ textTransform: 'none', borderRadius: 8 }}
              startIcon={<PlayArrowIcon />}
            >
              Watch Demo
            </Button>
          </Box>
        </Grid>

        {/* Right: hero image (md row 1 col right; xs order 4 = after IMF + stats) */}
        <Grid item xs={12} md={6} style={{ order: isMobile ? 4 : 2 }}>
          <Box
            style={{
              borderRadius: 16,
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              position: 'relative',
              width: '100%',
              height: isMobile ? 260 : 420,
            }}
          >
            <img
                src="/images/hero.png"
                alt="Kids Illustration"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            <Box
              style={{
                position: 'absolute',
                bottom: 8,
                right: 8,
                backgroundColor: 'white',
                padding: '4px 8px',
                borderRadius: 4,
                fontSize: 12,
                color: 'red',
                fontWeight: 'bold',
              }}
            >
            </Box>
          </Box>
        </Grid>

        {/* Friend of IMF — text left, logo right (xs order 2 / md 3) */}
        <Grid item xs={12} style={{ order: isMobile ? 2 : 3 }}>
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              gap: isMobile ? 12 : 14,
              background: "rgba(255,255,255,0.95)",
              border: "1px solid rgba(15, 59, 98, 0.16)",
              borderRadius: 12,
              padding: isMobile ? "14px 16px" : "16px 24px",
              boxShadow: "0 8px 24px rgba(15, 59, 98, 0.10)",
              marginBottom: isMobile ? 12 : 16,
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <Box
              style={{
                lineHeight: 1.2,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: 0,
              }}
            >
              <Typography style={{ fontSize: isMobile ? 17 : 20, fontWeight: 900, color: "rgb(15, 59, 98)" }}>
                Friend of IMF
              </Typography>
              <Typography style={{ fontSize: isMobile ? 14 : 16, fontWeight: 700, color: "rgba(15, 59, 98, 0.82)" }}>
                Indian Montessori Foundation
              </Typography>
            </Box>
            <img
              src="/images/imf-friend.png"
              alt="Indian Montessori Foundation"
              style={{
                width: isMobile ? 48 : 52,
                height: isMobile ? 48 : 52,
                borderRadius: 10,
                objectFit: "cover",
                objectPosition: "78% 92%",
                border: "1px solid rgba(15, 59, 98, 0.12)",
                background: "#fff",
                flexShrink: 0,
              }}
            />
          </Box>
        </Grid>

        {/* Stats — full content width (xs order 3 / md 4) */}
        <Grid item xs={12} style={{ order: isMobile ? 3 : 4 }}>
          <Box display="flex" justifyContent="space-between" width="100%">
            <Box>
              <Typography style={{ fontSize: isMobile ? "1.35rem" : "1.6rem", fontWeight: 800, lineHeight: 1.2 }}>
                75
              </Typography>
              <Typography style={{ fontSize: isMobile ? 13 : 14, fontWeight: 600, opacity: 0.85 }}>
                Schools in trial run
              </Typography>
            </Box>
            <Box>
              <Typography style={{ fontSize: isMobile ? "1.35rem" : "1.6rem", fontWeight: 800, lineHeight: 1.2 }}>
                20
              </Typography>
              <Typography style={{ fontSize: isMobile ? 13 : 14, fontWeight: 600, opacity: 0.85 }}>
                Schools subscribed
              </Typography>
            </Box>
            <Box>
              <Typography style={{ fontSize: isMobile ? "1.35rem" : "1.6rem", fontWeight: 800, lineHeight: 1.2 }}>
                50
              </Typography>
              <Typography style={{ fontSize: isMobile ? 13 : 14, fontWeight: 600, opacity: 0.85 }}>
                Planning to onboard
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeroSection;
